import { useBizMutation, useBizQuery } from '../Hooks/useBizQuery';
import { get, getPortalId, post } from './common';

export type EventInformationTab = {
	enabled: boolean;
	title: string;
	html: string;
};

const endpoint = 'api/event/information-tab';
const queryKey = (eventId: number) => ['EVENT_INFORMATION_TAB', getPortalId(), eventId] as const;

export function useEventInformationTab(eventId: number, forAdmin = false, enabled = true) {
	return useBizQuery(
		[...queryKey(eventId), forAdmin],
		() => get<EventInformationTab>(`${endpoint}?eventId=${eventId}&forAdmin=${forAdmin}`),
		enabled && eventId > 0,
		0,
		'always'
	);
}

export function useSaveEventInformationTab() {
	return useBizMutation(
		async ({ eventId, tab }: { eventId: number; tab: EventInformationTab }) => {
			const saved = await post<EventInformationTab>(`${endpoint}?eventId=${eventId}`, tab);
			if (!saved) throw new Error('The information could not be saved.');
			return saved;
		},
		{ getQueryKeyForInvalidation: ({ eventId }) => [queryKey(eventId)] }
	);
}
